import PropTypes from 'prop-types';
import React from 'react';
import css from './ErrorMessage.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ErrorMessage = function ErrorMessage(_ref) {
  var details = _ref.details,
      message = _ref.message;
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsx("h2", {
      children: "Time out! Something went wrong."
    }), /*#__PURE__*/_jsx("p", {
      children: message
    }), /*#__PURE__*/_jsx("details", {
      style: {
        whiteSpace: 'pre-wrap'
      },
      children: details.toString()
    })]
  });
};

ErrorMessage.propTypes = {
  details: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired
};
export default ErrorMessage;